import React from 'react'
import * as E from './bannerSectionElements'
import { Icon } from 'application/icons'
import { Link } from 'react-router-dom'

const BannerSection = ({
  data: { nlQuoteNumber, brand, userFirstName, isConsultant },
}) => {
  let estimateComparisonURL = isConsultant
    ? '/consultant/estimates'
    : '/estimates'

  let MaxxiaText = `Let’s get stuck in ${userFirstName}! Read up on the details of how you could drive your salary further with ${brand}.`
  let RemServText = `Let’s get stuck in ${userFirstName}! Read up on the details of how you can get into the driver’s seat with RemServ.`
  return (
    <E.BannerContainingDiv>
      <E.BannerTextDiv className="mb-5">
        {global.config.isBrandMX && (
          <Link to={estimateComparisonURL} tabIndex={-1}>
            {
              <E.BannerPrimaryButton extendInMob>
                <Icon iconType="BackArrowWhite" />
                {'  '}
                Back to comparison
              </E.BannerPrimaryButton>
            }
          </Link>
        )}

        {global.config.isBrandRS && (
          <E.BackToCompLink to={estimateComparisonURL}>
            <Icon iconType="BackArrowWhite" />
            Back to comparison
          </E.BackToCompLink>
        )}
        <E.BannerHeading>
          Explore your options: Estimate {nlQuoteNumber}
        </E.BannerHeading>
        <E.BannerSubheader id="bannerSection.subHeader" className="mt-4">
          {global.config.isBrandMX && MaxxiaText}
          {global.config.isBrandRS && RemServText}
        </E.BannerSubheader>
      </E.BannerTextDiv>
    </E.BannerContainingDiv>
  )
}

export default BannerSection
